function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.75,
  cy: 13.25,
  rx: 6,
  ry: 3,
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 13.25v7c0 1.66 2.69 3 6 3s6-1.34 6-3v-7",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 16.75c0 1.66-2.69 3-6 3s-6-1.34-6-3",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 15.75h6a1.5 1.5 0 001.5-1.5v-12a1.5 1.5 0 00-1.5-1.5H2.25a1.5 1.5 0 00-1.5 1.5v6.51"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.32 6.91a3 3 0 115.27 2.85M4.5 4.13a.37.37 0 01.38.37.38.38 0 01-.38.38.37.37 0 01-.37-.38.36.36 0 01.37-.37m15 7.49a.37.37 0 01.37.38.36.36 0 01-.37.37.37.37 0 01-.38-.37.38.38 0 01.38-.38"
}));

function SvgAccountingCoinsBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgAccountingCoinsBill;